// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store.js'
const fb = require('./firebaseConfig.js')
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/app.scss'
import VueSkycons from 'vue-skycons'
import VueHighlightJS from 'vue-highlightjs'
import fastclick from 'vue-fastclick';
import VueAnalytics from 'vue-analytics'

Vue.use(BootstrapVue);
Vue.use(VueSkycons);
Vue.use(require('vue-moment'));
Vue.use(VueHighlightJS);
Vue.use(VueAnalytics, {
  // id: 'UA-36541888-1', old GA for Craftsbury
  id: 'UA-36541888-9',
  router
})

Vue.config.productionTip = false

fastclick.attach(document.body);

// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
  })



// WEBPACK FOOTER //
// ./src/main.js